module.exports = __webpack_public_path__ + "media/images/overview-thorrel-bbd90906a65b952ea17d4e7552cafdd3.png";